"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weakMixingAngleDependencies = void 0;
var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var weakMixingAngleDependencies = exports.weakMixingAngleDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  createWeakMixingAngle: _factoriesAny.createWeakMixingAngle
};